import PropTypes from 'prop-types';
import React, {Component} from 'react';
import * as Colors from 'material-ui/styles/colors';
import styles from '../AccountPageStyles';
import {CustomSvgIcon} from 'crazyEditor/components/EditorUI/BaseUI/index';

export default class ReferralSteps extends Component {
  render() {
    const {number, iconSvgPath, text} = this.props;
    return (
      <span>
        <div
          style={{
            ...styles.container,
            flexDirection: 'column',
            justifyContent: 'flex-start',
            width: 180,
            height: 180,
            alignItems: 'center',
            marginRight: 10,
            marginLeft: 10,
            paddingLeft: 0,
          }}
        >
          <div
            style={{
              color: Colors.grey400,
              fontFamily: 'roboto',
              textAlign: 'center',
              fontSize: 20,
            }}
          >
            Step {number}
          </div>
          <CustomSvgIcon
            style={{
              marginTop: 20,
            }}
            height={50}
            width={50}
            path={iconSvgPath}
            color={Colors.orange800}
          />
          <div
            style={{
              fontSize: 16,
              fontFamily: 'roboto',
              color: Colors.grey700,
              textAlign: 'center',
              width: '100%',
              padding: 10,
            }}
            dangerouslySetInnerHTML={{__html: text}}
          />
        </div>
      </span>
    );
  }
}

ReferralSteps.propTypes = {
  iconSvgPath: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};
